import { render, staticRenderFns } from "./controlDigital.vue?vue&type=template&id=9e5d6be8&"
import script from "./controlDigital.vue?vue&type=script&lang=js&"
export * from "./controlDigital.vue?vue&type=script&lang=js&"
import style0 from "./controlDigital.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports